import React from 'react';
import BottomBarMenuContainer from './BottomBarMenuContainer';
import HeaderSearchBar from './HeaderSearchBar';

const BoardSearchContainer = () => {
  return (
    <>
      <BottomBarMenuContainer />
      <HeaderSearchBar />
    </>
  );
};

export default BoardSearchContainer;
